import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import ComentarioCeo from '@/components/ComentarioCeo'
import Cenario2018 from '@/components/Cenario2018'
import ubc2018emNumeros from '@/components/ubc2018emNumeros'
import aUbc from '@/components/aUbc'
import Arrecadacao from '@/components/Arrecadacao'
import Distribuicao from '@/components/Distribuicao'
import RelatoriosContabeis from '@/components/RelatoriosContabeis'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/Hotsite/Relatorio_Anual/2018/eng',
  routes: [
    { path: '/', name: 'Home', component: Home }, 
    { path: '/ubc-2018-in-numbers', name: 'ubc2018emNumeros', component: ubc2018emNumeros },
    { path: '/comment-from-the-ceo', name: 'ComentarioCeo', component: ComentarioCeo },
    { path: '/ubc-2018-in-retrospect', name: 'Cenario2018', component: Cenario2018 },
    { path: '/ubc', name: 'aUbc', component: aUbc },
    { path: '/collection', name: 'Arrecadacao', component: Arrecadacao },
    { path: '/distribution', name: 'Distribuicao', component: Distribuicao },
    { path: '/financial-reporting', name: 'RelatoriosContabeis', component: RelatoriosContabeis },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js